import {saleVehiclePhotoApi, useGetSaleVehicleFinancingStatusQuery} from '@dms/api/vehicle';

import {hasPendingFinancingPromo} from '../utils/hasPendingFinancingPromo';

const FINANCING_PROMO_POLLING_INTERVAL = 5_000;

interface UseFinancingPromoStatusProps {
  saleVehicleId: string;
  isEnabled: boolean;
  isRenderWindowOpen: boolean;
}

/**
 * Financing status of the gallery's promo cards. The BE renders the cards asynchronously, so the
 * status is refetched on mount and polled while a render window is open or a card is PENDING;
 * the endpoint refetches the promo tile sources when the rendered files change.
 */
export const useFinancingPromoStatus = (props: UseFinancingPromoStatusProps) => {
  const cachedFinancingPromoStatus =
    saleVehiclePhotoApi.endpoints.getSaleVehicleFinancingStatus.useQueryState({
      saleVehicleId: props.saleVehicleId,
    });
  const shouldPoll =
    props.isRenderWindowOpen || hasPendingFinancingPromo(cachedFinancingPromoStatus.data);

  const {data} = useGetSaleVehicleFinancingStatusQuery(
    {saleVehicleId: props.saleVehicleId},
    {
      skip: !props.isEnabled,
      pollingInterval: shouldPoll ? FINANCING_PROMO_POLLING_INTERVAL : 0,
      refetchOnMountOrArgChange: true,
    }
  );

  return data;
};
